(function (root) {
  'use strict';
  function getGuide(state) {
    const rest = state.goal === 'rest';
    const long = state.duration === 'long' || state.duration === 'ultra';
    let fuel = rest ? 'fuelDaily' : state.goal === 'before' ? 'fuelBefore' : state.goal === 'after' ? 'fuelAfter' : long ? 'fuelLong' : state.duration === 'medium' ? 'fuelMedium' : 'fuelShort';
    const hydration = !rest && (long || state.conditions === 'hot') ? 'sodium' : 'water';
    const recovery = { before: 'recoveryBefore', during: 'recoveryDuring', after: 'recoveryAfter', rest: 'recoveryRest' }[state.goal];
    const carry = rest || state.goal === 'after' ? 'home' : long ? 'carryLong' : 'carryShort';
    return {
      cards: [
        { message: fuel, anchor: 'fueling' },
        { message: hydration, anchor: 'hydration' },
        { message: recovery, anchor: 'sleep' },
        { message: carry, anchor: 'kit' }
      ],
      activity: state.activity,
      notices: rest ? ['rest'] : [...(state.conditions === 'hot' ? ['hot'] : []), ...(state.duration === 'ultra' ? ['ultra'] : [])]
    };
  }
  if (typeof module === 'object' && module.exports) module.exports = { getGuide };
  else root.ARVENTO_NR = { getGuide };
})(typeof globalThis !== 'undefined' ? globalThis : this);
